import { Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { ApisService } from '../../services/apis.service';
import { SnackbarComponent } from '../snackbar/snackbar.component';

/**
 * DialogComponent Componente que se encarga de mostrar un dialogo desde cualquier vista.
 * @author Santiago V. <snippetdeveloper@gmail.com>
 * @copyright (c) 2019 Snippet Developer.
 */

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html'
})
export class DialogComponent {
  constructor(private dialogRef: MatDialogRef<DialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public api: ApisService, public snackbar: SnackbarComponent) {}

  public remove() {
    this.removeUser();
  }

  removeUser() {
    this.api.removeUser(this.data.id).then(result => {
      if (result['status'] === 'success') {
        const that = this;
        setTimeout(function() { window.open('#/auth/' + that.data.root, '_self'); }, 1000);
        this.snackbar.show('Good, User successfully deleted.');
      } else {
        this.snackbar.show('Error deleting user.');
      }
    });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}

